import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { VoiceCreationService } from "@/services/integrations/elevenlabs/VoiceCreationService";
import { InstantVoiceCloneRequest, InstantVoiceCloneResponse } from "@/types/voice/voice-creation";

const voiceCreationService = VoiceCreationService.getInstance();

export const useInstantVoiceClone = () => {
  return useMutation<InstantVoiceCloneResponse, Error, InstantVoiceCloneRequest>({
    mutationFn: (payload) => voiceCreationService.createInstantVoiceClone(payload),
    onError: (error) => {
      console.error("Instant voice clone failed:", error);
      toast.error("Failed to create instant voice clone.");
    },
  });
};
